import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@deporvillage/utils-library-component';

import styles from './ReadMore.module.scss';

const ReadMore = ({ height, children, onClick }) => {

    const collapsedHeight = height || 60;

    const [hidden, setHidden] = React.useState(true);
    const [collapsed, setCollapsed] = React.useState(true);
    const [styleHeight, setStyleHeight] = React.useState(collapsedHeight);

    const contentRef = React.useRef(null);
    const wrapperRef = React.useRef(null);

    // istanbul ignore next
    const toggle = () => {
        setCollapsed(!collapsed);
        setStyleHeight(!collapsed ? collapsedHeight : contentRef.current.clientHeight);

        /* eslint-disable-next-line no-undef */
        window.scroll({
            /* eslint-disable-next-line no-undef */
            top: wrapperRef.current.getBoundingClientRect().top + window.scrollY - 180,
            behavior: 'smooth',
        });

        onClick && onClick({ collapsed: !collapsed });
    };

    // istanbul ignore next
    React.useEffect(() => {
        setHidden(contentRef.current.clientHeight <= collapsedHeight);
        setStyleHeight(collapsed ? collapsedHeight : contentRef.current.clientHeight);
    }, [children]);

    return (
        <div className={ styles[`read-more-component`] }>
            <div className={ styles[`read-more-wrapper`] } style={ { height: styleHeight } } ref={ wrapperRef }>
                <div className={ styles[`read-more-content`] } ref={ contentRef }>
                    <div className={ styles[`read-more-content-wrapper`] }>
                        { children }
                    </div>
                </div>
            </div>
            { /* istanbul ignore next */ hidden ? null :
                <div className={ styles[`read-more-toggle`] } onClick={ toggle }>
                    { collapsed ?
                        <Fragment><I18n>generic.actions.show_more</I18n> <i className="icon icon-arrow-down-keyboard"/></Fragment> :
                        <Fragment><I18n>generic.actions.show_less</I18n> <i className="icon icon-arrow-up-keyboard"/></Fragment>
                    }
                </div>
            }
        </div>
    );
};

ReadMore.propTypes = {
    height: PropTypes.number,
    children: PropTypes.element,
    onClick: PropTypes.func,
};

export default ReadMore;
